import type { CandidateJobApi } from '@/modules/candidates/types';

/**
 * A candidate whose first reach-out message is still a draft. Drafts are only
 * discoverable through the candidate list's `reachOutMessage`: the messages
 * endpoint has no job filter and the thread list hides draft-only threads.
 */
export const hasDraft = (candidateJob: CandidateJobApi) =>
  candidateJob.reachOutMessage?.status === 'Draft';

/**
 * `?review=drafts` keeps the review sheet open, so the `OutreachGenerated`
 * notification link (portalNotificationLink.ts) can open it.
 */
export const REVIEW_PARAM = 'review';
export const REVIEW_DRAFTS = 'drafts';
